import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import FormComponent from '../../../Reusable_Components/FormComponent';
import { API_ROUTES, API_DOMAIN, headers } from '../../../Reusable_Components/Config/apiConfig';

const OpportunityFollowUpInput = () => {
  const { followUpId = '' } = useParams();
  const decodedId = followUpId ? atob(followUpId) : followUpId;
  const id = decodedId.replace(/\D/g, '');
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({});
  const route = 'opportunityFollowUp';

  useEffect(() => {
    if (followUpId) {
      setIsEditing(true);
      fetchFollowUpDetails();
    }
  }, [followUpId]); // eslint-disable-line react-hooks/exhaustive-deps

  const fetchFollowUpDetails = async () => {
    try {
      const response = await axios.get(`${API_DOMAIN}${API_ROUTES.opportunityFollowUp}${id}/`, { headers });
      const d = response.data?.data ?? response.data;
      setFormData({
        id: d.id,
        opportunity: d.opportunity?.id ?? d.opportunity,
        description: d.description,
        due_date: d.due_date ? new Date(d.due_date).toISOString().split('T')[0] : '',
        assigned_user: d.assigned_user?.id ?? d.assigned_user,
      });
    } catch (error) {
      console.error('Error fetching follow-up details:', error);
    }
  };

  const followUpFields = [
    {
      name: 'opportunity', label: 'Related Opportunity', type: 'async-select',
      endpoint: API_ROUTES.opportunity,
      getOptionLabel: (o) => o.opportunity_name,
    },
    { name: 'description', label: 'Description', type: 'textarea' },
    { name: 'due_date', label: 'Due Date', type: 'date', dateConstraint: 'future' },
    {
      name: 'assigned_user', label: 'Assigned User', type: 'async-select',
      endpoint: API_ROUTES.users,
      getOptionLabel: (u) => u.username,
    },
  ];

  return (
    <div>
      <h1>{isEditing ? 'Edit Opportunity Follow-Up' : 'Create Opportunity Follow-Up'}</h1>
      <FormComponent fields={followUpFields} initialFormData={formData} route={route} />
    </div>
  );
};

export default OpportunityFollowUpInput;
